import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export default createReduxConstants('FEATURED_CONTENT', {
  FEATURED_CONTENT_REQUEST: null,
  FEATURED_CONTENT_SUCCESS: null,
  FEATURED_CONTENT_FAILURE: null
});
